import formatAnalyticsValue from '../format-analytics-value';
function getInteractionPayload(params, options) {
    const { action, category, divisionId = 'VT::VT', clientUuid, entity, flagEvaluationDetail, label, visitorId, sessionId, pageRequestId, userId, tests, domEventData, } = params;
    return {
        customEventData: {
            action: options.useFormatData ? formatAnalyticsValue(`${action}`, 'action') : action,
            category: options.useFormatData ? formatAnalyticsValue(`${category}`, 'category') : category,
            flagEvaluationDetail,
            label: label
                ? options.useFormatData
                    ? formatAnalyticsValue(`${label}`, 'label')
                    : label
                : undefined,
            value: params.value,
        },
        domEventData,
        page: {
            clientUuid,
            divisionId,
            entity,
            sessionId,
            url: window.location.href.slice(0, 799),
            userAgent: navigator.userAgent,
            visitorId,
            tests,
            userId,
        },
        pageRequestId: pageRequestId,
    };
}
export default getInteractionPayload;
